if (!customElements.get("show-more")) {
  customElements.define(
    "show-more",
    class ShowMore extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector(".bundle-desktop__grid");
        this.button = this.querySelector(".show-more__button");
        if (!this.grid || !this.button) return;

        const collapsedHeight = this.dataset.collapsedHeight || 400;
        this.style.setProperty("--collapsed-height", `${collapsedHeight}px`);

        this.setAttribute("data-collapsed", "");

        this.button.addEventListener("click", () => this.toggle());

        requestAnimationFrame(() => this.updateVisibility());
      }

      toggle() {
        const isCollapsed = this.hasAttribute("data-collapsed");

        this.toggleAttribute("data-collapsed");
        this.button.setAttribute("aria-expanded", String(isCollapsed));

        if (!isCollapsed) {
          this.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }

      updateVisibility() {
        if (this.grid.scrollHeight <= this.grid.clientHeight) {
          this.button.style.display = "none";
        }
      }
    },
  );
}
